module.exports = __webpack_public_path__ + "img/adenisov.b079ca99.png";